import { Base, ElementType } from './report-editor.model';

export class BaseElement {
    title: string;
    id: string;
    type: ElementType;

    constructor(base: Base) {
        this.title = base.title;
        this.id = base.id;
        this.type = base.type;
    }
}
